// We need to turn the uid into a deviceId that the analytics for the player can understand - eg. 00000000-0000-0000-0000-000000000000

const replaceRegEx = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};

const replaceAll = (str: string, find: string, replace: string) => {
  return str.replace(new RegExp(replaceRegEx(find), 'g'), replace);
};

export const formatDeviceId = (uid: string) => {
  // ReplaceAll does not work on Chrome versions below 85, so we do it manually through regex'
  const replacedUid = uid && uid.replace('.', '');
  return replaceAll(replacedUid, '.', '-') + '00000000';
};

export default formatDeviceId;
